import React, { useEffect, useState } from "react";
import CoreInput from "../../inputs/CoreInput";
import CoreFormHelperText from "../CoreFormHelperText";
import CoreSelect from "../../inputs/CoreSelect";
import CoreDatePicker from "../../inputs/CoreDatePicker";
import CoreAsyncSelect from "../../inputs/CoreAsyncSelect";
import { TABLE_DATA_FETCH_SUCCESS } from "../../../store/types/dtType";

export default function EditableCell({
  editData,
  col,
  onEdit,
  row,
  formikProps,
  inputTypeMap,
  inputValMap,
}) {
  const [colName, setColName] = useState(null);
  const [colId, setColId] = useState(null);

  useEffect(() => {
    if (checkId(col, col.id, editData)) {
      setColName(col?.name);
      setColId(typeof col.id === "function" ? col.id(row) : col.id);
    }
  }, [col, row, editData]);

  const checkId = (col, id, editData) => {
    if (typeof id === "function" && editData[col.id(row)]) {
      return true;
    } else return editData?.[id];
  };

  return checkId(col, col.id, editData) ? (
    <div>
      {inputTypeMap && inputTypeMap[colName] === "select" ? (
        <CoreSelect
          id={String(colId)}
          value={formikProps.values?.[colId]}
          formikProps={formikProps}
          handleChange={(val) => {
            onEdit(val, colId);
            formikProps.setFieldValue(colId, val);
          }}
          options={
            inputValMap && inputValMap[colName]
              ? Array.isArray(inputValMap[colName])
                ? inputValMap[colName]
                : []
              : []
          }
        />
      ) : inputTypeMap && inputTypeMap[colName] === "date" ? (
        <CoreDatePicker
          id={String(colId)}
          value={formikProps.values?.[colId]}
          formikProps={formikProps}
          onChange={(val) => {
            onEdit(val, colId);
            formikProps.setFieldValue(colId, val);
          }}
        />
      ) : inputTypeMap && inputTypeMap[colName] === "asyncselect" ? (
        <CoreAsyncSelect
          id={String(colId)}
          value={formikProps.values?.[colId]}
          formikProps={formikProps}
          onChange={(val) => {
            onEdit(val?.value, colId);
            formikProps.setFieldValue(colId, val?.value);
          }}
          apiPath={
            inputValMap && inputValMap[colName]
              ? inputValMap[colName]?.url
              : null
          }
          successType={["dt#" + colName]}
          errorType={["dt#" + colName]}
          asyncLoading
          reducerVar={colName}
          display={(item) => {
            return {
              value: item[inputValMap[colName]?.valueColumn || "name"],
              label: item[inputValMap[colName]?.labelColumn || "name"],
            };
          }}
          valueColumn={
            inputValMap && inputValMap[colName]
              ? inputValMap[colName]?.valueColumn
              : "name"
          }
        />
      ) : (
        <CoreInput
          id={String(colId)}
          onChange={(e) => {
            onEdit(e.target.value, colId);
            formikProps.handleChange(e);
          }}
          value={formikProps.values?.[colId]}
          formikProps={formikProps}
          type={
            inputTypeMap && inputTypeMap[colName]
              ? inputTypeMap[colName]
              : "text"
          }
        />
      )}
      {formikProps.errors && formikProps.errors[colId] ? (
        <CoreFormHelperText error>
          {formikProps.errors[colId]}
        </CoreFormHelperText>
      ) : null}
    </div>
  ) : col.view ? (
    col.view(row)
  ) : col.name ? (
    row[col.name]
  ) : (
    row[col.label]
  );
}
